import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { SkipToContent } from "./SkipToContent";
import { SiteNav } from "./SiteNav";
import { SiteFooter } from "./SiteFooter";

/**
 * Light-surface wrapper — used only for /privacy and /terms.
 * Body switches to --frac-white background with dark text; footer stays dark
 * for continuity.
 */
export function LegalLayout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    // Toggle a body class so any dark selection styles read differently on
    // light pages if needed later.
    document.body.classList.add("frac-legal-body");
    return () => document.body.classList.remove("frac-legal-body");
  }, [pathname]);

  return (
    <div className="min-h-screen bg-frac-white text-frac-black">
      <SkipToContent targetId="main-content" />
      <SiteNav variant="on-light" />
      <div className="h-[56px] md:h-[64px]" aria-hidden />
      <main id="main-content" tabIndex={-1} className="focus:outline-none">
        <Outlet />
      </main>
      <SiteFooter />
    </div>
  );
}

export default LegalLayout;
